import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import AAKeywordCreatePage from './aa-keyword-create'
import AAKeywordListPage from './aa-keyword-list'
import AAKeywordUpdatePage from './aa-keyword-update'

const aAKeyWordRoutes: Route[] = [
  {
    path: Paths.AA_KEYWORD_LIST_PAGE,
    element: <AAKeywordListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.AA_KEYWORD_CREATE_PAGE,
    element: <AAKeywordCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.AA_KEYWORD_UPDATE_PAGE,
    element: <AAKeywordUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default aAKeyWordRoutes
